// extracted by mini-css-extract-plugin
export default {"warning":"ChallengeWarnings_warning__7Umci","danger":"ChallengeWarnings_danger__b9VqC"};